import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UploadFundingDocumentMutationRequest, UploadFundingDocumentMutationResponse, UploadFundingDocumentQueryParams, UploadFundingDocument400, UploadFundingDocument401, UploadFundingDocument403, UploadFundingDocument404, UploadFundingDocument410, UploadFundingDocument422, UploadFundingDocument429, UploadFundingDocument500 } from "../types/UploadFundingDocument";

/**
 * @link /api/credit-flow-backend/v1/document/do_upload
 */

export function useUploadFundingDocument <TData = UploadFundingDocumentMutationResponse, TError = UploadFundingDocument400 | UploadFundingDocument401 | UploadFundingDocument403 | UploadFundingDocument404 | UploadFundingDocument410 | UploadFundingDocument422 | UploadFundingDocument429 | UploadFundingDocument500, TVariables = UploadFundingDocumentMutationRequest>(params: UploadFundingDocumentQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/credit-flow-backend/v1/document/do_upload`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
